import Radios from 'components/Formik/Radios';
import Select from 'components/Formik/Select';
import Text from 'components/Formik/Text';
import { useEffect } from 'react';

const BringGuest = ({ initialValues, formik, data }) => {
	initialValues.bringGuest = '';
	initialValues.guest = '';
	initialValues.relationship = '';
	useEffect(() => {
		formik.values.guest = '';
		formik.values.relationship = '';
	}, [formik.values.bringGuest]);
	const { bring_guest, guest_name, guest_relationship } = data;
	return (
		<div>
			<p>
				<strong>{bring_guest.label}</strong>
			</p>
			<Radios options={bring_guest.options} name='bringGuest' />
			{formik.values.bringGuest === 'yes' && (
				<>
					<Text label={guest_name} name='guest' />
					<Select
						label={guest_relationship.label}
						options={guest_relationship.options}
						name='relationship'
					/>
				</>
			)}
		</div>
	);
};

export default BringGuest;
